import React from "react"
import MetricsMapping from "components/SFDC/containers/MetricsMapping"
import IntegrationBreadcrumb from 'components/Integration/components/IntegrationBreadcrumb'

const SalesforceMetricsMapping = () => (
  <div className="common-integration-page-layout">    
    <IntegrationBreadcrumb 
      backLinkText="Salesforce Integration"
      backLinkUrl="/settings/setup/salesforce"
    />
    <header>
      <h2 className="integration-header">Send Chat Metrics to Salesforce</h2>
      <p>Map conversation metrics to Salesforce task fields</p>
    </header>
    <MetricsMapping />
  </div>
)

export default SalesforceMetricsMapping



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/SalesforceMetricsMapping/index.js